import { createElement } from 'react';
import type { Production } from 'sr-types/lib/search/v1/graphql';
import SortConfigFormItems from '../../../production/form/SortConfigFormItems';
import { ENTITIES } from '../../constants/customSortFieldConfigs';
import { normalizeSearchProductions } from '../transformers';
import type { EntityReportAdapter, EntityReportConfigureFormProps } from './EntityReportAdapter';

export const WORKSPACE_REPORT_ADAPTER_KEY = 'workspace-report-adapter';

export const workspaceEntityReportAdapter: EntityReportAdapter = {
    key: WORKSPACE_REPORT_ADAPTER_KEY,
    entity: ENTITIES.workspace,
    defaultReportPageSize: 200,
    normalizeRows: (rows, locale) => normalizeSearchProductions(rows as Production[], locale),
    getConfigureFormComponent: () =>
        function WorkspaceSortConfigFormItems(props: EntityReportConfigureFormProps) {
            return createElement(SortConfigFormItems, props);
        }
};
